import { Button, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';

type NoteSectionProps = {
  note: string | undefined | null;
  onEditClick: () => void;
  label?: string;
  sx?: {
    backgroundColor?: string;
    borderRadius?: string;
    padding?: string;
    wordBreak?: string;
    maxWidth?: string;
    width?: string;
  };
};

export const NoteSection = ({
  note,
  onEditClick,
  label = 'Notes',
  sx = {
    backgroundColor: '#f5f8fb',
    borderRadius: '2px',
    padding: '12px',
    wordBreak: 'break-word',
    width: '100%',
  },
}: NoteSectionProps) => {
  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 0 }}>
        <Typography variant="h6">{label}</Typography>
        <Button
          onClick={onEditClick}
          startIcon={<EditIcon />}
          sx={{ textTransform: 'none', minWidth: 'auto' }}
        >
          Edit
        </Button>
      </Stack>
      {note && (
        <Typography
          variant="body1"
          sx={{
            ...sx,
            padding: '2.4rem',
            paddingBottom: '1.6rem',
            mb: '-1.2rem',
            mt: '-1.2rem',
          }}
        >
          {note}
        </Typography>
      )}
    </>
  );
};
